module.exports = __webpack_public_path__ + "static/media/Calendar.9cbd9bd5.svg";